import { onDOMContentLoaded } from "tsi-common-react/src/utils/events";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

onDOMContentLoaded.on(async () => {
    const document = getDocument();
    if (!document) {
        return;
    }
    const productListNav = document.querySelector(".product-list-nav__list");
    if (!productListNav) {
        return;
    }
    const Flickity = (await import("flickity")).default;
    const flickity = new Flickity(productListNav, {
        watchCSS: true,
        draggable: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: true,
    });
    return flickity;
});
